<template>
  <div class="page-container">
    <slot />
  </div>
</template>

<script>
export default {
  name: "Page",
  components: {},
  data() {
    return {};
  },
  mounted() {
    let anchorTags = document.querySelectorAll("a");
    for (let i = 0; i < anchorTags.length; i++) {
      let el = anchorTags[i];
      this.goToPageListener(el);
    }
  },
  computed: {},
  methods: {
    goToPageListener(el) {
      el.addEventListener("click", (e) => {
        let windowOrigin = window.location.origin;
        if (e.target.href) {
          let href = e.target.href.replace(windowOrigin, "");

          // if the same page
          // console.log("Clicking", e.target.href, windowOrigin);

          if (href.startsWith("/") && href.includes("#")) {
            // scroll to element
            e.preventDefault();
            let id = "#" + href.split("#")[1];
            const y =
              document.querySelector(id).getBoundingClientRect().top +
              window.scrollY;
            window.scrollTo({
              top: y,
              behavior: "smooth",
            });
          } else if (href.startsWith("/") && !href.includes("#")) {
            // go to page
            e.preventDefault();
            this.goToPage(href);
          }
        }
      });
    },
    goToPage(page) {
      this.$store.dispatch("prepareToNavigate", {
        from: this.$route.path,
        to: page,
        position: window.scrollY,
      });
      this.$router.push(page);

      this.$store.dispatch("playBell");
    },
  },
};
</script>

<style>
.full-width-line {
  height: 1px;
  width: 100vw;
  position: relative;
  left: 50%;
  transform: translateX(-50%);
  background: #EAD9BE;
}

.full-width-line .full-width-gradient {
  height: 16rem;
  width: 100%;
  background: linear-gradient(180deg, rgba(253, 239, 218, 0) 0%, #FDEFDA 100%);
  left: 50%;
  transform: translate(-50%, -16rem);
  position: absolute;
}

.spacer {
  height: 4rem;
}

.toc {
  position: relative;
  width: 100%;
  padding: 2.4rem 1.2rem 2rem 1.2rem;
  box-sizing: border-box;
  z-index: 10;
}

.toc-header {
  display: flex;
  flex-direction: row;
  margin-bottom: 1.3rem;
}

.toc-header-svg {
  height: 5.5rem;
  width: 5.5rem;
  margin-left: 1.3rem;
  margin-right: 1.3rem;
}

.toc-header-svg .shape-svg {
  height: 100%;
  filter: blur(0.15rem);
}

.toc-header-svg .shape-svg g path {
  stroke-width: 4px;
}

.toc-header-title {
  font-family: "Andale", monospace;
  font-style: normal;
  font-weight: 400;
  font-size: 1.8rem;
  line-height: 150%;
  color: var(--orange);
  -webkit-text-stroke: 0.1rem var(--orange);
  filter: blur(0.1rem);
}

.toc-rows {
  width: 100%;
}

.toc-row {
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: baseline;
  padding: 0.8rem 1.2rem;
  box-sizing: border-box;
  border-radius: 8px;
  text-decoration: none;
  background: transparent;
  transition: all 200ms ease-in-out;
}

.toc-row-bottom {
  height: 1px;
  bottom: 0;
  left: 1.2rem;
  width: calc(100% - 2.4rem);
  position: absolute;
  background: #EAD9BE;
  transition: all 200ms ease-in-out;
}

.toc-row:last-child .toc-row-bottom {
  display: none;
}

.toc-row-title,
.toc-row-scroll {
  font-family: "Scala";
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  line-height: 150%;
  color: var(--black);
}

.toc-row-scroll {
  font-family: "Andale";
  font-size: 1.5rem;
  font-weight: 700;
  color: #A08C6B;
  font-variant-numeric: tabular-nums;
}

.toc-row:hover {
  background: #F1E6D5;
  cursor: pointer;
}

.toc-row:nth-child(4) .toc-row-bottom {
  display: none;
}

.toc-border {
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  width: 100%;
  border: 3px solid var(--orange);
  filter: blur(0.15rem);
  z-index: -1;
  pointer-events: none;
  background: var(--tan-01);
  box-sizing: border-box;
}

.toc-feet {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 0 4rem;
  box-sizing: border-box;
  z-index: 10;
  position: relative;
}

.toc-foot-1,
.toc-foot-2 {
  height: 2.4rem;
  width: 3px;
  filter: blur(0.15rem);
  background: var(--orange);
}

.toc-feet.blue .toc-foot-1,
.toc-feet.blue .toc-foot-2 {
  background: var(--blue);
}

.toc.blue .toc-border {
  border: 3px solid var(--blue);
}

.toc-feet.green .toc-foot-1,
.toc-feet.green .toc-foot-2 {
  background: var(--green);
}

.toc.green .toc-border {
  border: 3px solid var(--green);
}

.toc .toc-content {
  padding: 1.3rem;
  padding-top: 1.1rem;
}

.toc .toc-content p {
  margin: 0;
}

.toc.toc--is-shape {
  padding: 2.4rem 1.2rem 1.2rem 1.2rem;
}

.toc.toc--is-shape .toc-header {
  height: 0;
  margin: 0;
  padding-bottom: 5.5rem;
  margin-top: -5rem;
}

.toc.toc--is-shape .toc-header .toc-header-svg g path {
  stroke-width: 3px;
  fill: var(--tan-01);
}

@media (max-width: 655px) {
  .toc-row-title {
    font-size: 2.5rem;
  }

  .toc-row-scroll {
    font-size: 2rem;
  }
}
</style>
